var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _rect2, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    id: "library",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 15,
    x2: 15,
    y1: 51,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54a5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ad3fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 43,
    x2: 43,
    y1: 51,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb369"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 27.5,
    x2: 27.5,
    y2: 9,
    xlinkHref: "#a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 6,
    x: 7,
    y: 51,
    fill: "#9db8d3",
    rx: 2,
    ry: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M12 19h6a2 2 0 0 1 2 2v30H10V21a2 2 0 0 1 2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ad3fe",
    d: "M32 22h4a2 2 0 0 1 2 2v27h-8V24a2 2 0 0 1 2-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb369",
    d: "M50 22h2a2 2 0 0 1 2 2v27h-6V24a2 2 0 0 1 2-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M40 16h6a2 2 0 0 1 2 2v33H38V18a2 2 0 0 1 2-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb7f58",
    d: "M22 7h1a2 2 0 0 1 2 2v42h-5V9a2 2 0 0 1 2-2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M27 9h1a2 2 0 0 1 2 2v40h-5V11a2 2 0 0 1 2-2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 37,
    r: 3,
    fill: "#d7e9f7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ad3fe",
    d: "M17 44h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2zm0 4h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb369",
    d: "M20 38h5v6h-5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 22,
    x: 41,
    y: 23,
    fill: "#eb7f58",
    rx: 2,
    ry: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7e9f7",
    d: "M34 47a1 1 0 0 1-1-1V26a1 1 0 0 1 2 0v20a1 1 0 0 1-1 1Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.7686212d88a0d093bf3ca60e34a65cf1.svg";
export { ForwardRef as ReactComponent };